import { Map , List } from 'immutable';
import { actionTypes as ReadersAndAntennasViewActionsType } from '../../../actions/Administration/RfidSettingsPage/readersAndAntennasViewActions';

let defaultState = {
  loading: false,
  selectedDeviceApp : null,
  deviceAppsOptions : []
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case ReadersAndAntennasViewActionsType.ADMINISTRATION_RF_SETTINGS_READERS_AND_ANTENNAS_FETCH_DEVICE_APPS_IN_PROCESS:
      return state.set('loading', true);

    case ReadersAndAntennasViewActionsType.ADMINISTRATION_RF_SETTINGS_READERS_AND_ANTENNAS_FETCH_DEVICE_APPS_READY:
      state = state.set('deviceAppsOptions', action.payload);
      return state.set('loading',false);

    case ReadersAndAntennasViewActionsType.ADMINISTRATION_RF_SETTINGS_READERS_AND_ANTENNAS_DEVICE_APP_CHANGED:
      return state.set('selectedDeviceApp', action.payload);

    default:
      return state;
  }

}







